<template>
    <div class="tabBot">
        <!-- 导航栏 -->
        <div v-for="(item, idx) in list" :class="['box' , item.class]" :key="idx" @click="nav(item.target)">
            <img :src="item.img" alt="" class="img">
            <span v-text="item.text"></span>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .tabBot{
        width: 100%;
        height: 48px;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: fixed;
        z-index: 999;
        background: #fff;
        bottom: 0;
        left: 0;
        border-top: 1px solid #f5f5f5;
        .box{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            height: 76%;
            width: (100%/3);
            span{
                font-size:12px;
                font-family:SourceHanSansCN-Light;
                font-weight: normal;
                color:rgba(51,51,51,1);
            }
        }
        .img{
            // width: 18px;
            height: 18px;
        }
    }
</style>
<script>
    import { NavBar } from 'vant'; 
    import api from "@/utils/js/api.js"
    export default {
        data(){
          return {
            isSdkReady: false,
            list: [
                {   
                    img: this.$store.state.api.imgUrl + 'index.png',
                    text: '首页',
                    class: 'box1',
                    w: 15,
                    h: 15,
                    target: 'index'
                },
                {   
                    img: this.$store.state.api.imgUrl + 'message.png',
                    text: '客服',
                    class: 'box2',
                    w: 13,
                    h: 14,
                    target: 'kefu'
                },
                {   
                    img: this.$store.state.api.imgUrl + 'my.png',
                    text: '我的',
                    class: 'box3',
                    w: 13,
                    h: 14,
                    target: 'my'
                },

            ]
          }
        },
        name: 'tabBot',
        props: {
            msg: String,
            channelId: String
        },
        created(){

        },
        methods: {
            nav(_target) {
                if(_target == 'message'){
                    _kf();
                }else if(_target == 'my'){
                    this.$router.push({
                        name: _target,
                        query: {
                            channelId: this.channelId
                        }
                    })
                }else{
                    this.$router.push({
                        name: _target,
                        params: {},

                    })
                }
            }
        },
    
    }
</script>